export const EventTypes = {
    menu: {
        clicked: 'menu.clicked',
        createCollection: {
            clicked: 'menu.create_collection.clicked'
        }
    },
    collection: {
        create: {
            success: 'collection.create.success'
        },
        item: {
            create: {
                success: 'collection.item.create.success',
                too_many_items: 'collection.item.create.too_many_items'
            },
            delete: {
                success: 'collection.item.delete.success'
            }
        },
        storage: {
            success: 'collection.storage.success',
            failure: 'collection.storage.failure'
        }
    }
};
